<template>
  <div :class="`quick-access col-lg-${options.colSize || 6}`">
    <list-groups :options="options">

      <small slot="action" class="text-muted label label-success">
        {{ pagination.total }}
      </small>

      <b-list-group-item
        slot="card"
        v-for="item in items"
        :key="item.id" :href="options.link.href + item.id || '#!'"
        :target="options.link.target || '_self'"
        class="flex-column align-items-start">

        <div class="d-flex w-100 justify-content-between">

          <h5 class="mb-1">
            {{ item.name || 'Anónimo' }}
          </h5>

          <small v-if="item.created_at">
            {{ item.created_at | moment('DD/MM/YYYY HH:mm') }}
          </small>

        </div>

        <p class="mb-1" v-if="item.body">
          {{ item.subject || 'Sem Assunto' }}<br/>
          {{ item.body | truncate(100) }}
        </p>

        <small v-if="item.city && item.city.representation">
          {{ item.city.representation }}
        </small>

        <div v-if="item.attachments.length > 0">
          <i class="fa fa-paperclip"></i> {{ item.attachments.length }} Anexos
        </div>

      </b-list-group-item>

    </list-groups>
  </div>
</template>

<script>
import { resolveHTTP } from '@/services/api'

export default {
  name: 'widget-bl-contacts',
  data () {
    return {
      items: [],
      pagination: [],
      options: {
        name: 'Últimos contatos',
        caption: '',
        icon: 'fa fa-envelope',
        colSize: 6,
        entity: {
          url: '/bl/contacts',
          params: {
            per_page: 5,
            _order: 'id:desc',
            _with: 'attachments.file'
          }
        },
        link: {
          href: '/#/bl-contacts/',
          target: '_self'
        }
      }
    }
  },
  methods: {
    refresh () {
      let self = this
      resolveHTTP(self.options.entity.url).index({
        params: self.options.entity.params
      }).then(function (res) {
        self.items = res.data.collection
        self.pagination = res.data.pagination
      })
    }
  },
  created () {
    this.refresh()
  }
}
</script>

<style lang="scss" scoped>
  .card-header {
    .card-actions {
      .label {
       padding: 5px 10px;
       border-radius: 2px;
     }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/widgets/Bl/Contacts.vue